var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpiral2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 251.77 175.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        mix-blend-mode: hard-light;\n      }\n\n      .cls-5 {\n        isolation: isolate;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 251.77,
    height: 175.95
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 54.82,
    cy: 0.71,
    r: 1.09,
    transform: "translate(15.37 38.78) rotate(-44.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 47.82,
    cy: 2.63,
    r: 1.05,
    transform: "translate(12.56 35.04) rotate(-45.74)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 40.7,
    cy: 4.01,
    r: 1.02,
    transform: "translate(8.12 28.74) rotate(-42.83)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 33.49,
    cy: 4.84,
    r: 0.99,
    transform: "translate(5.97 24.53) rotate(-43.8)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 26.24,
    cy: 5.12,
    r: 0.95,
    transform: "translate(3.39 19) rotate(-42.32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 18.99,
    cy: 4.85,
    r: 0.92,
    transform: "translate(1.65 13.99) rotate(-42.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.48,3.47c.31.38.24.94-.14,1.25-.38.31-.94.24-1.25-.14s-.24-.94.14-1.25.94-.24,1.25.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.33,2.12c.29.37.23.91-.14,1.2s-.91.23-1.2-.14c-.29-.37-.23-.91.14-1.2.37-.29.91-.23,1.2.14Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 75.62,
    cy: -0.28,
    r: 1.1,
    transform: "translate(34.67 63.29) rotate(-57)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 68.64,
    cy: 3.21,
    r: 1.06,
    transform: "translate(29.87 59.94) rotate(-58.33)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 61.42,
    cy: 6.16,
    r: 1.03,
    transform: "translate(23.23 54.65) rotate(-57.51)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 53.99,
    cy: 8.55,
    r: 0.99,
    transform: "translate(17.93 49.63) rotate(-57.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.9,9.56c.45.28.59.86.32,1.31s-.86.59-1.31.32c-.45-.28-.59-.86-.32-1.31s.86-.59,1.31-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.18,10.81c.43.27.57.83.3,1.26s-.83.57-1.26.3-.57-.83-.3-1.26.83-.57,1.26-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M31.39,11.48c.42.25.55.8.29,1.22s-.8.55-1.22.29-.55-.8-.29-1.22.8-.55,1.22-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.56,11.54c.4.24.53.77.28,1.17s-.77.53-1.17.28-.53-.77-.28-1.17c.24-.4.77-.53,1.17-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.77,11c.38.23.5.74.27,1.12-.23.38-.74.5-1.12.27s-.5-.74-.27-1.12c.23-.38.74-.5,1.12-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.03,9.86c.37.22.48.7.26,1.07-.22.37-.7.48-1.07.26s-.48-.7-.26-1.07.7-.48,1.07-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M.41,8.14c.35.21.46.67.25,1.02s-.67.46-1.02.25-.46-.67-.25-1.02.67-.46,1.02-.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 90.72,
    cy: -0.58,
    r: 1.06,
    transform: "translate(65.45 86.55) rotate(-73.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.92,3.04c.56.11.91.65.8,1.21-.11.56-.65.91-1.21.8s-.91-.65-.8-1.21.65-.91,1.21-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.58,7.15c.54.11.88.63.77,1.17s-.63.88-1.17.77-.88-.63-.77-1.17.63-.88,1.17-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68.95,10.69c.51.1.85.61.74,1.12s-.61.85-1.12.74-.85-.61-.74-1.12.61-.85,1.12-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M61.07,13.63c.49.1.81.58.71,1.08s-.58.81-1.08.71-.81-.58-.71-1.08.58-.81,1.08-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.99,15.95c.47.1.78.56.68,1.03s-.56.78-1.03.68-.78-.56-.68-1.03.56-.78,1.03-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M44.76,17.64c.45.09.75.53.65.99s-.53.75-.99.65-.75-.53-.65-.99.53-.75.99-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.43,18.7c.43.09.71.51.62.94s-.51.71-.94.62-.71-.51-.62-.94c.09-.43.51-.71.94-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.04,19.13c.41.08.68.49.59.9s-.49.68-.9.59-.68-.49-.59-.9.49-.68.9-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.65,18.93c.39.08.64.46.56.85s-.46.64-.85.56-.64-.46-.56-.85c.08-.39.46-.64.85-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.3,18.09c.37.08.61.44.53.81s-.44.61-.81.53-.61-.44-.53-.81.44-.61.81-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3.04,16.6c.35.07.58.41.5.76s-.41.58-.76.5-.58-.41-.5-.76.41-.58.76-.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.74,1.95c.54-.08,1.04.29,1.12.83s-.29,1.04-.83,1.12-1.04-.29-1.12-.83.29-1.04.83-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.43,7.26c.51-.08.99.28,1.07.79s-.28.99-.79,1.07-.99-.28-1.07-.79.28-.99.79-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.73,12c.49-.07.95.27,1.02.76s-.27.95-.76,1.02-.95-.27-1.02-.76.27-.95.76-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.7,16.14c.47-.07.91.25.98.72s-.25.91-.72.98-.91-.25-.98-.72.25-.91.72-.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68.39,19.66c.45-.07.86.24.93.69s-.24.86-.69.93-.86-.24-.93-.69.24-.86.69-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.83,22.54c.42-.06.82.23.88.65s-.23.82-.65.88-.82-.23-.88-.65.23-.82.65-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.08,24.75c.4-.06.78.22.84.62s-.22.78-.62.84-.78-.22-.84-.62.22-.78.62-.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.19,26.29c.38-.06.73.2.79.58s-.2.73-.58.79-.73-.2-.79-.58.2-.73.58-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.22,27.14c.36-.05.69.19.74.55s-.19.69-.55.74-.69-.19-.74-.55.19-.69.55-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.2,27.29c.33-.05.65.18.7.52s-.18.65-.52.7-.65-.18-.7-.52.18-.65.52-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.21,26.75c.31-.05.6.17.65.48s-.17.6-.48.65-.6-.17-.65-.48.17-.6.48-.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.28,25.52c.29-.04.56.16.6.45s-.16.56-.45.6-.56-.16-.6-.45.16-.56.45-.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.46-1.27c.45-.24,1.01-.08,1.25.37s.08,1.01-.37,1.25-1.01.08-1.25-.37-.08-1.01.37-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M109.35,5.35c.43-.23.96-.07,1.19.35s.07.96-.35,1.19-.96.07-1.19-.35-.07-.96.35-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M101.76,11.4c.41-.22.91-.07,1.13.34s.07.91-.34,1.13-.91.07-1.13-.34-.07-.91.34-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.74,16.86c.38-.21.86-.07,1.07.32s.07.86-.32,1.07-.86.07-1.07-.32-.07-.86.32-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.32,21.69c.36-.2.82-.06,1.01.3s.06.82-.3,1.01-.82.06-1.01-.3-.06-.82.3-1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.56,25.84c.34-.19.77-.06.95.28s.06.77-.28.95-.77.06-.95-.28-.06-.77.28-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.51,29.31c.32-.17.72-.06.89.26s.06.72-.26.89-.72.06-.89-.26-.06-.72.26-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.22,32.07c.3-.16.67-.05.83.25s.05.67-.25.83-.67.05-.83-.25-.05-.67.25-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48.75,34.11c.28-.15.62-.05.78.23s.05.62-.23.77-.62.05-.77-.23-.05-.62.23-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M39.16,35.42c.26-.14.58-.04.72.21s.04.58-.21.72-.58.04-.72-.21-.04-.58.21-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.49,35.99c.23-.13.53-.04.66.19s.04.53-.19.66-.53.04-.66-.19-.04-.53.19-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.82,35.82c.21-.12.48-.04.6.18s.04.48-.18.6-.48.04-.6-.18-.04-.48.18-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.18,34.91c.19-.1.43-.03.54.16s.03.43-.16.54-.43.03-.54-.16-.03-.43.16-.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 0.82,
    cy: 33.58,
    r: 0.35,
    transform: "translate(-17.09 5.16) rotate(-30.82)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.2,1.17c.29-.33.8-.36,1.13-.07s.36.8.07,1.13-.8.36-1.13.07-.36-.8-.07-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.88,8.59c.28-.31.75-.34,1.07-.07s.34.75.07,1.07-.75.34-1.07.07-.34-.75-.07-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.01,15.43c.26-.29.71-.32,1-.06s.32.71.06,1-.71.32-1,.06-.32-.71-.06-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.64,21.63c.24-.27.66-.3.93-.06s.3.66.06.93-.66.3-.93.06-.3-.66-.06-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M94.82,27.17c.22-.25.61-.28.87-.05s.28.61.05.87-.61.28-.87.05-.28-.61-.05-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.61,32.02c.21-.23.57-.26.8-.05s.26.57.05.8-.57.26-.8.05-.26-.57-.05-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.05,36.15c.19-.22.52-.24.73-.05s.24.52.05.73-.52.24-.73.05-.24-.52-.05-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.21,39.54c.17-.2.47-.21.67-.04s.21.47.04.67-.47.21-.67.04-.21-.47-.04-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.15,42.16c.16-.18.42-.19.6-.04s.19.42.04.6-.42.19-.6.04-.19-.42-.04-.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 46.19,
    cy: 44.26,
    r: 0.38,
    transform: "translate(-17.5 50.29) rotate(-49.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.57,45.07c.12-.14.33-.15.47-.03s.15.33.03.47-.33.15-.47.03-.15-.33-.03-.47Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 25.39,
    cy: 45.52,
    r: 0.28,
    transform: "translate(-25.63 34.85) rotate(-49.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.8,44.79c.09-.1.24-.11.33-.02s.11.24.02.33-.24.11-.33.02-.11-.24-.02-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.5,43.45c.07-.08.19-.09.27-.02s.09.19.02.27-.19.09-.27.02-.09-.19-.02-.27Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 9.08,
    cy: 54.06,
    r: 4.17,
    transform: "translate(-40.65 30.99) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: -1.98,
    cy: 52.22,
    r: 4.12,
    transform: "translate(-43.94 21.07) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M138.82,3.22c.13-.34.52-.51.86-.37s.51.52.37.86-.52.51-.86.37-.51-.52-.37-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M131.29,11.51c.12-.31.48-.47.79-.34s.47.48.34.79-.48.47-.79.34-.47-.48-.34-.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M123.16,19.19c.11-.29.44-.43.73-.32s.43.44.32.73-.44.43-.73.32-.43-.44-.32-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.46,26.23c.1-.26.4-.39.66-.29s.39.4.29.66-.4.39-.66.29-.39-.4-.29-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M105.26,32.59c.09-.24.36-.35.59-.26s.35.36.26.59-.36.35-.59.26-.35-.36-.26-.59Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 95.97,
    cy: 38.37,
    r: 0.41,
    transform: "translate(23.56 112.12) rotate(-67.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.53,43.1c.07-.18.28-.27.46-.2s.27.28.2.46-.28.27-.46.2-.27-.28-.2-.46Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 75.41,
    cy: 47.29,
    r: 0.3,
    transform: "translate(2.95 98.99) rotate(-67.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.44,50.45c.05-.13.2-.19.33-.14s.19.2.14.33-.2.19-.33.14-.19-.2-.14-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.54,52.89c.04-.1.16-.16.26-.11s.16.16.11.26-.16.16-.26.11-.16-.16-.11-.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 42.62,
    cy: 54.52,
    r: 0.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 31.43,
    cy: 55.23,
    r: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 20.22,
    cy: 55.07,
    r: 0.05
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 62.07,
    cy: 61.92,
    r: 4.48,
    transform: "translate(-24.09 78.13) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 50.22,
    cy: 64.13,
    r: 4.43,
    transform: "translate(-31.07 69.31) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 38.23,
    cy: 65.42,
    r: 4.37,
    transform: "translate(-37.35 59.98) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 26.17,
    cy: 65.8,
    r: 4.32,
    transform: "translate(-42.9 50.2) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 14.13,
    cy: 65.24,
    r: 4.26,
    transform: "translate(-52.53 68.81) rotate(-80.84)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2.16,
    cy: 63.75,
    r: 4.21,
    transform: "translate(-10.22 1.18) rotate(-9.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.36,4.86c0-.27.23-.49.5-.48s.49.23.48.5-.23.49-.5.48-.49-.23-.48-.5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 144.1,
    cy: 14.11,
    r: 0.44,
    transform: "translate(119.68 156.83) rotate(-85.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M135.29,22.72c0-.21.18-.38.39-.37s.38.18.37.39-.18.38-.39.37-.38-.18-.37-.39Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 126.61,
    cy: 30.69,
    r: 0.33,
    transform: "translate(88.29 155.2) rotate(-86.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.69,37.91c0-.15.13-.27.28-.27s.27.13.27.28-.13.27-.28.27-.27-.13-.27-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.57,44.38c0-.12.1-.22.22-.21s.22.1.21.22-.1.22-.22.21-.22-.1-.21-.22Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 96.14,
    cy: 50.05,
    r: 0.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 85.09,
    cy: 54.88,
    r: 0.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 73.7,
    cy: 58.84,
    r: 0.05
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 118.51,
    cy: 50.38,
    r: 4.82,
    transform: "translate(9.97 119.67) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 107.34,
    cy: 56.96,
    r: 4.76,
    transform: "translate(-.32 113.32) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 95.7,
    cy: 62.68,
    r: 4.7,
    transform: "translate(-10.1 106.21) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 83.66,
    cy: 67.49,
    r: 4.64,
    transform: "translate(-19.3 98.36) rotate(-55.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 71.29,
    cy: 71.36,
    r: 4.58,
    transform: "translate(-9.78 11.35) rotate(-8.52)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 58.65,
    cy: 74.26,
    r: 4.53,
    transform: "translate(-26.63 33.26) rotate(-26.02)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 45.83,
    cy: 76.18,
    r: 4.47,
    transform: "translate(-34.76 38.63) rotate(-33.99)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 32.89,
    cy: 77.11,
    r: 4.41,
    transform: "translate(-10.96 5.66) rotate(-8.44)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 19.93,
    cy: 77.04,
    r: 4.35,
    transform: "translate(-11.46 3.91) rotate(-8.73)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 7,
    cy: 75.98,
    r: 4.29,
    transform: "translate(-11.82 2.04) rotate(-9.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.87,6.03c-.05-.15.03-.32.19-.37s.32.03.37.19-.03.32-.19.37-.32-.03-.37-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157.02,16.29c-.04-.12.03-.26.15-.3s.26.03.3.15-.03.26-.15.3-.26-.03-.3-.15Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 148.57,
    cy: 25.85,
    r: 0.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 139.17,
    cy: 34.79,
    r: 0.12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 129.13,
    cy: 42.99,
    r: 0.06
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpiral2);
export default __webpack_public_path__ + "static/media/spiral-2.6f68894e2045337c89c2a1e9b50e1758.svg";
export { ForwardRef as ReactComponent };